import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
const MobileMenuSlide = ({ mobilePage, children }) => {
    return _jsx("div", { className: cn("header__mobile-menu-page", mobilePage.isOpen ? "animate-slideleft-right" : "animate-slideoutleft-right"), children: children });
};
export default MobileMenuSlide;
